import React from "react";

// Converte um trecho de HTML (ex.: rótulo de termos de uso configurado no evento) em
// elementos React por allowlist, sem innerHTML: só ficam links e formatação simples;
// qualquer outra tag é "desembrulhada" (mantém o texto) e script/style são descartados.
// Links só com http(s), mailto ou tel, sempre em nova aba com rel="noopener noreferrer".

const ALLOWED_TAGS = new Set(["a", "b", "strong", "i", "em", "u", "br"]);
const DROPPED_TAGS = new Set(["script", "style", "iframe", "object", "embed", "svg", "math"]);
const ALLOWED_PROTOCOLS = ["http:", "https:", "mailto:", "tel:"];

// href seguro ou null
function safeHref(value) {
  if (!value) return null;
  try {
    const url = new URL(value, window.location.origin);
    return ALLOWED_PROTOCOLS.includes(url.protocol) ? url.href : null;
  } catch (error) {
    return null;
  }
}

function toReact(node, key) {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent;
  if (node.nodeType !== Node.ELEMENT_NODE) return null;

  const tag = node.tagName.toLowerCase();
  if (DROPPED_TAGS.has(tag)) return null;

  const children = Array.from(node.childNodes)
    .map((child, index) => toReact(child, `${key}-${index}`))
    .filter((child) => child !== null && child !== "");

  if (!ALLOWED_TAGS.has(tag)) return children.length ? <React.Fragment key={key}>{children}</React.Fragment> : null;
  if (tag === "br") return <br key={key} />;

  if (tag === "a") {
    const href = safeHref(node.getAttribute("href"));
    if (!href) return <React.Fragment key={key}>{children}</React.Fragment>;
    return (
      <a key={key} href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }

  return React.createElement(tag, { key }, children);
}

// Devolve string (sem HTML) ou um array de nós React prontos para renderizar.
export function renderSafeHtml(html) {
  const text = html === null || html === undefined ? "" : String(html);
  if (!/[<&]/.test(text)) return text;

  const doc = new DOMParser().parseFromString(text, "text/html");
  return Array.from(doc.body.childNodes)
    .map((node, index) => toReact(node, `n${index}`))
    .filter((node) => node !== null && node !== "");
}
